import { Injectable, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { ReportingLocalStorageUtil } from 'src/app/utils/reporting-localstorage.util';

@Injectable({
  providedIn: 'root',
})
export class ReportingNavigationResetService implements OnDestroy {
  private navigationSubscription?: Subscription;
  private previousUrl = '';
  private isInitialized = false;

  private readonly reportingDashboardPrefix = '/reporting_dashboard';

  constructor(private readonly router: Router) {}

  init(): void {
    if (this.isInitialized) return;
    this.isInitialized = true;
  
    this.previousUrl = this.router.url ?? '';
  
    this.navigationSubscription = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        const currentUrl = event.urlAfterRedirects ?? '';
  
        const wasInReporting = this.previousUrl.startsWith(this.reportingDashboardPrefix);
        const isInReporting = currentUrl.startsWith(this.reportingDashboardPrefix);
  
        // Reset teams filters when navigating from non-reporting → reporting
        if (!wasInReporting && isInReporting) {
          ReportingLocalStorageUtil.clearAllTeamsFilters();
        }
  
        this.previousUrl = currentUrl;
      });
  }

  ngOnDestroy(): void {
    this.navigationSubscription?.unsubscribe();
  }
}